"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5154],{

/***/ 65154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64593);





var MetaTagGenerator = function(param) {
    var metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaImage = param.metaImage, metaUrl = param.metaUrl, forceNoIndex = param.forceNoIndex, noFollow = param.noFollow, noCanonical = param.noCanonical;
    var commonMeta = [
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1"
        },
        {
            name: "description",
            content: metaDescription || "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition"
        },
        {
            property: "og:locale",
            content: "en_US"
        },
        {
            property: "og:type",
            content: "website"
        }, 
    ];
    if ([
        "production"
    ].includes("production" || 0) && forceNoIndex) {
        commonMeta.push({
            property: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        }, {
            property: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        }, {
            name: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        }, {
            name: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        });
    }
    var metaData = [
        "production"
    ].includes("production" || 0) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(commonMeta).concat([
        {
            property: "og:title",
            content: metaTitle || "Quattr Inc | Grow Your Web Traffic 2X Faster"
        },
        {
            property: "og:description",
            content: metaDescription || "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition"
        },
        {
            property: "og:url",
            content: metaUrl || "https://www.quattr.com"
        },
        {
            property: "og:site_name",
            content: "Quattr"
        },
        {
            property: "og:image",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            property: "og:image:secure_url",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            property: "og:image:width",
            content: "1369"
        },
        {
            property: "og:image:height",
            content: "1027"
        },
        {
            name: "twitter:card",
            content: "summary_large_image"
        },
        {
            name: "twitter:domain",
            content: "quattr.com"
        },
        {
            name: "twitter:url",
            content: metaUrl || "https://www.quattr.com"
        },
        {
            name: "twitter:description",
            content: metaDescription || "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition"
        },
        {
            name: "twitter:title",
            content: metaTitle || "Quattr Inc | Grow Your Web Traffic 2X Faster"
        },
        {
            name: "twitter:site",
            content: "@Quattr"
        },
        {
            name: "twitter:image",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            name: "twitter:image:src",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            name: "twitter:creator",
            content: "@Quattr"
        }, 
    ]) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(commonMeta).concat([
        {
            property: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            property: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            name: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            name: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            property: "og:title",
            content: metaTitle || "[".concat("production", "] Quattr Inc | Grow Your Web Traffic 2X Faster")
        }, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: metaTitle || ([
                            "production"
                        ].includes("production" || 0) ? "Quattr Inc | Grow Your Web Traffic 2X Faster" : "[".concat("production", "] Quattr Inc | Grow Your Web Traffic 2X Faster"))
                    }),
                    [
                        "production"
                    ].includes("production" || 0) && !noCanonical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl || "https://www.quattr.com"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet__WEBPACK_IMPORTED_MODULE_3__/* .Helmet */ .q, {
                htmlAttributes: {
                    lang: "en"
                },
                meta: metaData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MetaTagGenerator);


/***/ })

}]);